import { Component, Input } from '@angular/core';
import { FormControl } from '@angular/forms';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import english from './i18n/en.json';
import spanish from './i18n/es.json';
import portuguese from './i18n/pt.json';

import { LocationGroup } from '@core/interfaces';
import { Apollo } from 'apollo-angular';
import gql from 'graphql-tag';
import { sentry } from 'sentry';


const SEARCH_QUERY = gql`
  query searchSegments($where: LocationGroupWhereInput, $limit: Int, $offset: Int) {
    locationsGroups(
      where: $where
      orderBy: name_asc
      limit: $limit
      offset: $offset
    ){
      items {
        id
        name
      }
    }
  }
`;

@Component({
  selector: 'locations-groups',
  templateUrl: './locations-groups.component.html',
  styleUrls: ['./locations-groups.component.scss'],
})
export class LocationsGroupsComponent {

  @Input() public control: FormControl;

  @Input()
  public showSearchIcon = false;

  @Input()
  public requiredMark = false;

  @Input()
  public preloadOptions = false;

  @Input()
  public searchOnFocus = false;

  @Input()
  public enableInfiniteScroll = true;

  @Input()
  public translateErrorPrefix: string;

  constructor(
    private fuseTranslationLoaderService: FuseTranslationLoaderService,
    private readonly apollo: Apollo
  ) {
    this.fuseTranslationLoaderService.loadJsonTranslations({ english, portuguese, spanish });
    this.search = this.search.bind(this);
    this.displayWith = this.displayWith.bind(this);
  }

  public async search(searchTerm: string, limit: number, offset: number): Promise<LocationGroup[]> {
    return this.apollo
      .query({
        query: SEARCH_QUERY,
        variables: {
          where: {
            name_contains: searchTerm,
            archived: false
          },
          limit,
          offset
        },
      })
      .toPromise()
      .then((result) => {
        return result.data['locationsGroups']['items'];
      })
      .catch((err) => {
        sentry.captureException(err);
        return [];
      });
  }

  public displayWith(value: LocationGroup): string {
    return value && value.name;
  }
}
